import type { ReactNode } from "react";

import { cn } from "@utils/cn";

interface TableViewLayoutProps {
  title: ReactNode;
  summary?: ReactNode;
  controls?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  contentClassName?: string;
}

/** Shared surface and header treatment for full-page operational tables. */
export const TableViewLayout = ({
  title,
  summary,
  controls,
  children,
  footer,
  className,
  contentClassName,
}: TableViewLayoutProps) => (
  <section className={cn("overflow-hidden rounded-xl border border-border-default bg-surface-base shadow-sm dark:border-border-default-dark dark:bg-surface-base-dark", className)}>
    <div className="border-b border-border-subtle px-5 py-3 dark:border-border-subtle-dark">
      <div className="min-w-0 text-sm font-semibold text-content-primary dark:text-content-primary-dark">
        {title}
        {summary && <p className="mt-1 text-sm font-normal text-content-secondary dark:text-content-secondary-dark">{summary}</p>}
      </div>
      {controls && <div className="mt-3 w-full">{controls}</div>}
    </div>
    <div className={contentClassName}>{children}</div>
    {footer && <div className="border-t border-border-subtle dark:border-border-subtle-dark">{footer}</div>}
  </section>
);
